import type { ApiProductionSession, ApiTodayPlan } from '@/features/kitchen/api/getTodayProduction'

export type ProductionSummary = {
  openSessionCount: number
  inProgress: number
  drafts: number
  planPct: number
  planTotal: number
  actualTotal: number
  planCode: string
  planCount: number
}

export function buildProductionSummary(plan: ApiTodayPlan, sessions: ApiProductionSession[]): ProductionSummary {
  const openSessions = sessions.filter((s) => s.status !== 'posted')
  const inProgress = openSessions.filter((s) => s.status === 'in_progress').length
  const drafts = openSessions.filter((s) => s.status === 'draft').length

  const mergedLines = plan.merged_lines ?? []
  const planTotal = mergedLines.reduce((sum, line) => sum + line.target_qty, 0)
  const planSkus = new Set(mergedLines.map((line) => line.product_name.toLowerCase()))

  let actualOnPlan = 0
  const actualBySku = new Map<string, number>()

  for (const session of sessions) {
    if (session.status === 'draft') continue
    for (const line of session.lines) {
      if (line.qty <= 0) continue
      const name = line.product_name.trim()
      actualBySku.set(name, (actualBySku.get(name) ?? 0) + line.qty)
    }
  }

  for (const line of mergedLines) {
    actualOnPlan += actualBySku.get(line.product_name) ?? 0
  }

  let actualTotal = actualOnPlan
  for (const [sku, qty] of actualBySku) {
    if (!planSkus.has(sku.toLowerCase())) actualTotal += qty
  }

  const planPct = planTotal > 0 ? Math.min(100, Math.round((actualOnPlan / planTotal) * 100)) : 0
  if (sessions.length === 0 && mergedLines.length > 0) {
    const serverActual = mergedLines.reduce((sum, line) => sum + (line.produced_qty ?? 0), 0)
    return {
      openSessionCount: openSessions.length,
      inProgress,
      drafts,
      planPct: planTotal > 0 ? Math.min(100, Math.round((serverActual / planTotal) * 100)) : 0,
      planTotal,
      actualTotal: serverActual,
      planCode:
        plan.plans.length === 1
          ? plan.plans[0].plan_code
          : plan.plans.length > 1
            ? `${plan.plans.length} plan HO`
            : 'Belum ada plan',
      planCount: plan.plans.length,
    }
  }

  const planCode =
    plan.plans.length === 1
      ? plan.plans[0].plan_code
      : plan.plans.length > 1
        ? `${plan.plans.length} plan HO`
        : 'Belum ada plan'

  return {
    openSessionCount: openSessions.length,
    inProgress,
    drafts,
    planPct,
    planTotal,
    actualTotal,
    planCode,
    planCount: plan.plans.length,
  }
}
